// original: https://git.hubteam.com/HubSpot/ui-addon-conversations-settings/blob/a3074a0a75dfbdb23ad52e6a2e9a41799014b3b1/static/js/team/operators/toOptionWithDepth.tsx
import { ROUTING_SOURCE } from '../../shared/constants/routing-source';
import { getTeamContainsFreeUsers } from './getTeamContainsFreeUsers';
import { getId, getName, getNumRoutableUsers } from './getters';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';

// TODO: Remove getDropdownStyle once all consumers migrated to use getSpaceToken for padding
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getDropdownStyle = levelsDeep => {
  return {
    paddingLeft: 20 * levelsDeep
  };
};

// Map pixel values to space tokens
const getPaddingLeftToken = level => {
  switch (level) {
    case 1:
      return 400;
    // 16px
    case 2:
      return 800;
    // 32px
    case 3:
      return 1100;
    // 48px
    case 4:
      return 1400;
    // 64px
    case 5:
      return 1500;
    // 96px
    default:
      return 200;
    // default padding
  }
};

// couldn't use an arrow function because Prettier didn't like the generic parameter
function getText(team, routingSource) {
  const numRoutableTeamUsers = getNumRoutableUsers(team);
  return /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx("span", {
      children: getName(team)
    }), typeof numRoutableTeamUsers === 'number' ? /*#__PURE__*/_jsx(Text, {
      as: "span",
      color: "icon-core-subtle",
      marginInlineStart: "100",
      typography: "detail-200",
      children: routingSource === true || routingSource === ROUTING_SOURCE.HELP_DESK ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "routing-ui.users-and-teams.team.routableUser",
        options: {
          count: numRoutableTeamUsers
        }
      }) : ` (${numRoutableTeamUsers})`
    }) : null]
  });
}

// couldn't use an arrow function because Prettier didn't like the generic parameter
export function toOptionWithDepth(team, depth, routingSource) {
  return {
    containsFreeUsers: getTeamContainsFreeUsers(team),
    // TODO: Remove dropdownStyle once all consumers migrated to use paddingLeft for padding
    dropdownStyle: getDropdownStyle(depth),
    paddingLeft: getPaddingLeftToken(depth),
    text: getText(team, routingSource),
    title: getName(team) || '',
    value: getId(team) || 0
  };
}